uniform vec3 uBoxMin;
uniform vec3 uBoxMax;
attribute vec3 position;

varying float vHeightColor;

float map(float value, float min1, float max1, float min2, float max2) {
  return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
}

void main() {
  vHeightColor = map(position.y, uBoxMin.y, uBoxMax.y, 0.0, 1.0);

  float x = map(position.x, uBoxMin.x, uBoxMax.x, -1.0, 1.0);
  float y = map(position.z, uBoxMin.z, uBoxMax.z, -1.0, 1.0);

  gl_Position = vec4(x, y, 0.0, 1.0);
}